import React from 'react';

const MapIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M9.5 3l6 3.7 6-2.1v13.9l-6.2 3.3-6-3.8L3 20.4V5.3L9.5 3zm10 4.4l-3.1 1.2v10.3l3.2-1.6V7.4zm-9.1-1.5v10.4l4 2.5V8.4l-4-2.5zm-2-.4L5 6.7v10.8l3.4-1.3V5.5z" />
  </svg>
);

export default MapIcon;
